import React from 'react'

const VacancyPage = () => (
  <div><h1>空室情報</h1></div>
)

export default VacancyPage


// WEBPACK FOOTER //
// ./src/VacancyPage.js